'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _gridUtils = require('../../../utils/grid/gridUtils');

var _ElementImage = require('../../../components/images/ElementImage');

var _ElementImage2 = _interopRequireDefault(_ElementImage);

var _Spinner = require('../../../components/loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _mediaConstants = require('../../../../common/media/mediaConstants');

require('./LinkImage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkImage = function LinkImage(_ref) {
    var element = _ref.element,
        gridSize = _ref.gridSize;

    var linkData = element.getIn(['content', 'link']);
    if (!linkData) return null;

    var fetching = element.getIn(['attachment', 'fetching']);
    var fetchingAttchment = linkData.get('hasAttachment') && fetching;
    var showAttachment = element.getIn(['content', 'showAttachment']);

    if (fetchingAttchment) {
        return _react2.default.createElement(
            'div',
            { className: 'LinkImage loading' },
            _react2.default.createElement(
                'div',
                { className: 'spinner-container' },
                _react2.default.createElement(_Spinner2.default, { show: true })
            )
        );
    }

    if (!showAttachment) return null;

    return _react2.default.createElement(
        'div',
        { className: 'LinkImage' },
        _react2.default.createElement(_ElementImage2.default, {
            element: element,
            imageType: _mediaConstants.IMAGE_TYPES.ELEMENT,
            size: (0, _gridUtils.gridPointsToPixels)(34, gridSize) })
    );
};

LinkImage.propTypes = {
    element: _react2.default.PropTypes.object,
    gridSize: _react2.default.PropTypes.number
};

exports.default = LinkImage;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/link/richMedia/LinkImage.js
// module id = 2004
// module chunks = 0